import validate from "/codebuild/output/src668455868/src/anchorage/node_modules/nuxt/dist/pages/runtime/validate.mjs";
import redirect_45trailing_45slash_45global from "/codebuild/output/src668455868/src/anchorage/apps/frontend/middleware/redirect-trailing-slash.global.js";
export const globalMiddleware = [
  validate,
  redirect_45trailing_45slash_45global
]
export const namedMiddleware = {}